<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import UIKit from '@pocketprep/ui-kit'
import PendingStudentHead from '@/components/PendingStudentHead.vue'
import ResendInviteSidePanel from '@/components/SidePanels/ResendInvite.vue'
import { examModule } from '@/store/exam/module'
import { groupModule } from '@/store/group/module'
import { studentModule } from '@/store/student/module'

const {
    Button: PocketButton,
    EmptyState,
} = UIKit

const route = useRoute()

const showResendInviteEmailSidePanel = ref(false)

const currentPendingStudentId = computed(() => {
    return route.params.studentId as string
})

const closeResendInviteSidePanel = () => {
    showResendInviteEmailSidePanel.value = false
}

const openResendInviteSidePanel = () => {
    showResendInviteEmailSidePanel.value = true
}

onBeforeRouteUpdate((to, from, next) => {
    // Re-initialize all our stuff to maintain progress state
    groupModule.actions.updateCurrentGroupId(to.params.groupId as string)
    studentModule.actions.updateCurrentStudentId(to.params.studentId as string)
    // Start polling on swap
    next()
})

onMounted(async () => {
    const routeGroupId = route.params.groupId
    const routeStudentId = route.params.studentId

    await Promise.all([
        groupModule.actions.updateCurrentGroupId(routeGroupId as string),
        studentModule.actions.updateCurrentStudentId(routeStudentId as string),
        examModule.actions.fetchCurrentStudentCurrentExam(),
    ])
})
</script>

<template>
    <div class="pending-student-stats">
        <ResendInviteSidePanel
            :org-student-ids="[ currentPendingStudentId ]"
            v-if="showResendInviteEmailSidePanel"
            @close="closeResendInviteSidePanel"
        />
        <PendingStudentHead
            class="pending-student-stats__head"
        />
        <EmptyState
            class="pending-student-stats__empty"
            title="This student hasn't accepted their invite yet."
            message="Once they activate their license, their stats will appear here."
        >
            <template #imageRow>
                <img
                    class="pending-student-stats__image"
                    src="@/assets/images/pending-student-empty.png"
                >
            </template>
        </EmptyState>
        <PocketButton
            class="pending-student-stats__resend-invite-email-btn"
            @click="openResendInviteSidePanel"
        >
            Resend Invite
        </PocketButton>
    </div>
</template>

<style lang="scss" scoped>
.pending-student-stats {
    :deep(.uikit-empty-state__message) {
        max-width: 260px;
        margin: 0 auto;
    }

    :deep(.uikit-empty-state__title) {
        max-width: 305px;
        margin: 15px auto 8px auto;
    }
    &__head {
        margin-bottom: 56px;
    }

    &__empty {
        min-width: 424px;
        margin: 120px auto 0px auto;

    }

    &__image {
        width: 65px;
        height: 92px;
    }

    &__resend-invite-email-btn {
        display: table;
        margin: 22px auto;
    }
}
</style>
